import { Box, Typography } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import { SelectChangeEvent } from "@mui/material/Select";
import SearchableSelect from "app/components/SearchableSelect";
import * as React from "react";
import { useStyles } from "./styles";

interface SelectInputProps {
  label?: string;
  containerStyle?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  name?: string;
  onChange?: (e: SelectChangeEvent) => void;
  value?: string;
  disabled?: boolean;
  error?: string;
  options?: Array<{ label: string; value: string }>;
  searchable?: boolean;
}

export default function SelectInput({
  label,
  containerStyle,
  inputStyle,
  labelStyle,
  name,
  onChange,
  value,
  disabled,
  error,
  options = [],
  searchable,
}: SelectInputProps) {
  const classes = useStyles();
  return (
    <Box style={containerStyle}>
      {label && (
        <InputLabel style={labelStyle} className={classes.label}>
          {label}
        </InputLabel>
      )}
      <SearchableSelect
        options={options}
        value={value}
        disabled={disabled}
        name={name}
        searchable={searchable}
        error={!!error}
        inputSx={inputStyle as any}
        onChange={(val) => {
          if (onChange) {
            onChange({
              target: { name, value: String(val) },
            } as SelectChangeEvent);
          }
        }}
      />
      {error && (
        <Typography component="small" className={classes.error}>
          {error}
        </Typography>
      )}
    </Box>
  );
}
